import "./ContentLoader.global.scss";

// Export something to ensure chunk generation
export const forceChunkByExporting = () => {
  // This function can be called if needed, but the main purpose is chunk generation
};
